/* eslint-disable */
import React, { useState, useEffect } from 'react';

const scoreColor = (score) => {
  if (score < 20) return '#ef4444';
  if (score < 50) return '#f59e0b';
  return '#22c55e';
};

export default function AktivitetsscorePanel() {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const hent = () =>
      fetch('/api/os/sags-diagnostik/aktivitetsscore', { credentials: 'include' })
        .then(r => r.json())
        .then(setData)
        .catch(console.error)
        .finally(() => setLoading(false));
    hent();
    const interval = setInterval(hent, 300000);
    return () => clearInterval(interval);
  }, []);

  if (loading) return <div style={{ color: '#94a3b8', padding: 32 }}>Beregner aktivitetsscorer...</div>;
  if (!data)   return <div style={{ color: '#ef4444', padding: 32 }}>Fejl ved hentning</div>;

  return (
    <div>
      <div style={{ color: '#64748b', fontSize: 13, marginBottom: 20 }}>
        Aktivitetsscore 0-100 baseret på haendelsestype og alder. Lavest score = mest kritisk.
      </div>
      <div style={{ display: 'flex', flexDirection: 'column', gap: 8 }}>
        {(data.sager || []).slice(0, 25).map((s, i) => (
          <div
            key={s.id}
            style={{
              display: 'flex', alignItems: 'center', gap: 12,
              padding: '10px 12px', background: '#0f172a', borderRadius: 8, cursor: 'pointer',
            }}
            onClick={() => window.open(`https://app.skilsmissevejen.dk/sager/${s.id}`, '_blank')}
            onMouseEnter={e => e.currentTarget.style.background = '#1e293b'}
            onMouseLeave={e => e.currentTarget.style.background = '#0f172a'}
          >
            <div style={{ color: '#374151', fontWeight: 700, width: 24, textAlign: 'right', fontSize: 12 }}>
              #{i + 1}
            </div>
            <div style={{ flex: 1 }}>
              <div style={{ color: '#e2e8f0', fontSize: 13 }}>{s.fornavn} {s.efternavn}</div>
              <div style={{ color: '#4b5563', fontSize: 11 }}>{s.type || '—'} · {s.initialer || 'Ingen'}</div>
            </div>
            <div style={{ width: 120 }}>
              <div style={{ background: '#1e293b', borderRadius: 4, height: 6, overflow: 'hidden' }}>
                <div style={{
                  width: `${s.score || 0}%`,
                  background: scoreColor(s.score || 0),
                  height: '100%', borderRadius: 4, transition: 'width 0.5s',
                }} />
              </div>
            </div>
            <div style={{ color: scoreColor(s.score || 0), fontWeight: 700, fontSize: 14, width: 36, textAlign: 'right' }}>
              {s.score || 0}
            </div>
            <div style={{ color: '#374151', fontSize: 11, width: 60, textAlign: 'right' }}>
              {s.haendelser_30d} hdl.
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
